import { render, staticRenderFns } from "./JdsSelectFieldOption.vue?vue&type=template&id=cd39dd5c&scoped=true&"
import script from "./JdsSelectFieldOption.vue?vue&type=script&lang=ts&"
export * from "./JdsSelectFieldOption.vue?vue&type=script&lang=ts&"
import style0 from "./JdsSelectFieldOption.vue?vue&type=style&index=0&id=cd39dd5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd39dd5c",
  null
  
)

export default component.exports